import {
  Module,
  PostOption,
  SectionPostOptions,
} from '../../../../helpers/types'

/* getThreadModule takes a post component's post options and converts them to a dynamic module Component */
export default function getThreadModule(
  sectionPostOptions: SectionPostOptions,
  module: Module
): SectionPostOptions {
  if (module.componentName === 'twitter_thread_poll') {
    return {
      pollOptionNumber:
        parseInt(
          (module.twitterThreadPollOptionNumber as PostOption)?.selected
            ?.title || '',
          10
        ) || 2,
      pollOne: sectionPostOptions.twitterThreadPollOne || '',
      pollTwo: sectionPostOptions.twitterThreadPollTwo || '',
      pollThree: sectionPostOptions.twitterThreadPollThree || '',
      pollFour: sectionPostOptions.twitterThreadPollFour || '',
    }
  } else if (module.componentName === 'twitter_thread_retweet') {
    return {
      retweetUrl: sectionPostOptions.twitterThreadRetweetRetweetUrl || '',
      snapshotUrl: sectionPostOptions.twitterThreadRetweetSnapshotUrl || '',
      refreshedAt: sectionPostOptions.twitterThreadRetweetRefreshedAt || '',
    }
  } else {
    return {}
  }
}
